type PaymentMethod = {code?: string};

export function checkoutGrandTotal(liveTotal: unknown, quoteTotal: unknown = 0): number {
  const prefer = liveTotal !== undefined && liveTotal !== null && liveTotal !== '' ? liveTotal : quoteTotal;
  const amount = Number(prefer);
  return Number.isFinite(amount) ? amount : 0;
}

export function restrictFreePaymentMethods<T extends PaymentMethod>(methods: T[], grandTotal: number = 0): T[] {
  if (grandTotal > 0) {
    return methods.filter((method) => method?.code !== 'free');
  }

  const free = methods.find((method) => method?.code === 'free');
  return free ? [free] : methods;
}

export function needsHostedPayment(grandTotal: number, methodCode: string): boolean {
  if (grandTotal <= 0) {
    return false;
  }

  return !methodCode.includes('checkmo');
}

export function placeOrderMethodCode(
  selectedCode: string,
  methods: PaymentMethod[],
  grandTotal: number,
): string {
  return grandTotal <= 0 && methods.some((method) => method?.code === 'free')
    ? 'free'
    : selectedCode;
}
